import { t } from "i18n-js";
import { getHttpClient, errorDesconocido, handle401 } from "../../../../core/utils/httpClient";
import basicRequest from "../../../../core/redux/actions/request";
import { notification } from "antd";

const PREFIX = "MANAGER_PURCHASE_ORDER_SHOW";
const getState = (state) => state.manager.purchaseOrder.show;

const {
    getPattern,

    actionPostPattern,
    actionPutPattern,
    actionDeletePattern,

    requestPattern,

    error,
    loading,
    success,
    reset,
    secondaryError,
    secondaryLoading,
    isSecondaryLoading,
    secondarySuccess,
    secondaryReset: formReset,

    isLoaded,
    isLoading,
    getError,
    getData,

    getSecondarySuccess: getFormSuccess,
    getSecondaryError: getFormError,

    generalDownload,
} = basicRequest(PREFIX, getState);

export const load = (id) => getPattern("manager/purchase-orders/v1/" + id, {}, null);

export {
    reset,
    isLoading,
    isLoaded,
    getError,
    getData,
    getFormSuccess,
    getFormError,
    formReset,
    isSecondaryLoading,
    success,
};

export const downloadFile = (id, name) => generalDownload(`manager/purchase-orders/v1/${id}/download.xlsx`, name);

export const removeTaskFromPOVendor = (id, purchaseOrderTaskId) =>
    actionDeletePattern(
        "manager/purchase-orders/v1/" + id + "/task/" + purchaseOrderTaskId,
        {},
        {
            message: "Removed",
            description: "The Task was removed from the CPO",
        }
    );

export const acceptPurchaseOrder = (id) =>
    actionPutPattern(
        "manager/purchase-orders/v1/" + id + "/accept",
        {},
        {
            message: "Updated",
            description: "PurchaseOrder was accepted!",
        }
    );

export const revertPurchaseOrder = (id) =>
    actionPutPattern(
        "manager/purchase-orders/v1/" + id + "/revert",
        {},
        {
            message: "Updated",
            description: "PurchaseOrder was reverted!",
        }
    );

export const createRectification = (id, purchaseOrderTaskId, form) =>
    actionPostPattern("manager/purchase-orders/v1/" + id + "/rectification/" + purchaseOrderTaskId, form, {
        message: "Updated",
        description: "Rectification created",
    });

export const includeRectification = (id, purchaseOrderTaskId) =>
    actionPutPattern(
        "manager/purchase-orders/v1/" + id + "/rectification/" + purchaseOrderTaskId,
        {},
        {
            message: "Updated",
            description: "Rectification included",
        }
    );

export const deleteRectification = (id, purchaseOrderTaskId) =>
    actionDeletePattern(
        "manager/purchase-orders/v1/" + id + "/rectification/" + purchaseOrderTaskId,
        {},
        {
            message: "Updated",
            description: "Rectification deleted",
        }
    );

export const addPayment = (id, form) =>
    actionPostPattern("manager/purchase-orders/v1/" + id + "/payment", form, {
        message: "Updated",
        description: "The payment has been added!",
    });

export const deletePayment = (id, paymentId) =>
    actionDeletePattern(
        "manager/purchase-orders/v1/" + id + "/payment/" + paymentId,
        {},
        {
            message: "Updated",
            description: "Payment deleted",
        }
    );

export const addInvoice = (id, form) =>
    actionPostPattern("manager/purchase-orders/v2/" + id + "/invoice", form, {
        message: "Updated",
        description: "The invoice has been uploaded!",
    });

export const confirmInvoice = (id, invoiceId) =>
    actionPutPattern(
        `manager/purchase-orders/v2/${id}/invoice/${invoiceId}/confirm`,
        {},
        {
            message: "Updated",
            description: "The invoice has been confirmed!",
        }
    );

export const revertInvoice = (id, invoiceId) =>
    actionPutPattern(
        `manager/purchase-orders/v2/${id}/invoice/${invoiceId}/revert`,
        {},
        {
            message: "Updated",
            description: "The invoice has been reverted!",
        }
    );

export const downloadInvoice = (id, name) => generalDownload(`manager/vendor-invoices/v1/${id}/download`, name);

export const removeInvoice = (id, invoiceId) =>
    actionDeletePattern(
        `manager/purchase-orders/v2/${id}/invoice/${invoiceId}`,
        {},
        {
            message: "Updated",
            description: "The invoice has been deleted!",
        }
    );
